import instance from "../../../shared/components/auth/service/AxiosInstance";

export const JobService = {

    getJobs: (pageNo, pageSize) =>
        instance.get(process.env.REACT_APP_API_URL + "job/" +
            '?pageSize=' + pageSize +
            '&pageNo=' + pageNo
    ),
}